// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1HuzQ","header":"ReportDetails_header__3GtBW","title":"ReportDetails_title__2_sLh","left":"ReportDetails_left__16AJ5"};